import { useContext } from "react";
import UploadAdvisorContext from "../contexts/UploadAdvisorContext";

const useUploadAdvisor = () => {
  return useContext(UploadAdvisorContext);
};

export default useUploadAdvisor;
